import React, { useEffect, useRef } from 'react';
import { CIEN_CUADRAS_BLUE } from '../firebase/firebaseConfig';

declare var L: any; // Declare Leaflet global object

interface PropertyLocationMapProps {
    latitude: number;
    longitude: number;
    propertyType: string;
    address: string;
    className?: string;
}

const createCustomMarkerIcon = () => {
    const iconHtml = `
        <div style="
            background-color: ${CIEN_CUADRAS_BLUE};
            width: 28px;
            height: 28px;
            border-radius: 50% 50% 50% 0;
            transform: rotate(-45deg);
            border: 3px solid white;
            box-shadow: 0 4px 8px rgba(0,0,0,0.3);
            display: flex;
            justify-content: center;
            align-items: center;
        ">
            <div style="
                width: 12px;
                height: 12px;
                background-color: white;
                border-radius: 50%;
                transform: rotate(45deg);
            "></div>
        </div>`;
    
    return L.divIcon({
        html: iconHtml,
        className: '', // Avoid default leaflet styles interfering
        iconSize: [34, 34],
        iconAnchor: [17, 34]
    });
};

export const PropertyLocationMap: React.FC<PropertyLocationMapProps> = ({ latitude, longitude, address, className = 'h-80 w-full' }) => {
    const mapRef = useRef<HTMLDivElement>(null);
    const mapInstance = useRef<any>(null); // To hold the map instance

    useEffect(() => {
        if (mapRef.current && !mapInstance.current && typeof L !== 'undefined') {
            const map = L.map(mapRef.current, { scrollWheelZoom: false }).setView([latitude, longitude], 16);
            mapInstance.current = map;

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);

            const customIcon = createCustomMarkerIcon();
            const marker = L.marker([latitude, longitude], { icon: customIcon }).addTo(map);
            // marker.bindPopup(`<b>${address}</b>`).openPopup(); // REMOVED to hide the default white popup

            // This is crucial for maps that are initially hidden
            setTimeout(() => {
                map.invalidateSize();
            }, 100); 
        } else if (mapInstance.current) {
            // If the component re-renders but the map is already initialized, just ensure its size is correct.
             setTimeout(() => {
                mapInstance.current.invalidateSize();
            }, 100);
        }

        return () => {
            if (mapInstance.current) {
                mapInstance.current.remove();
                mapInstance.current = null;
            }
        };
    }, [latitude, longitude, address]); // Re-run effect if location changes

    return <div ref={mapRef} className={`${className} rounded-lg z-0`}></div>;
};